import { FRAMECATEGORY } from './kitchenConfig';
import { CornerCabinetDirection } from './enum';
import { getTopCabinetLengthInfo } from './lengthUtils';
/**
 * 获取底柜的frame
 * @param templateJson templatejson
 * @returns 所有边的frame组成的数组
 */
export function getAllBottomFrame(templateJson) {
    var _a, _b, _c, _d, _e, _f;
    const { bottom } = templateJson;
    const frames = [];
    if ((_a = bottom === null || bottom === void 0 ? void 0 : bottom.length1) === null || _a === void 0 ? void 0 : _a.frames) {
        frames.push((_b = bottom === null || bottom === void 0 ? void 0 : bottom.length1) === null || _b === void 0 ? void 0 : _b.frames);
    }
    if ((_c = bottom === null || bottom === void 0 ? void 0 : bottom.length2) === null || _c === void 0 ? void 0 : _c.frames) {
        frames.push((_d = bottom === null || bottom === void 0 ? void 0 : bottom.length2) === null || _d === void 0 ? void 0 : _d.frames);
    }
    if ((_e = bottom === null || bottom === void 0 ? void 0 : bottom.length3) === null || _e === void 0 ? void 0 : _e.frames) {
        frames.push((_f = bottom === null || bottom === void 0 ? void 0 : bottom.length3) === null || _f === void 0 ? void 0 : _f.frames);
    }
    return { frames };
}
/**
 *
 * @param longEdge 转角柜长边所在边
 * @param edge 转角柜对象所在边
 */
export function getCornerCabinetDirection(longEdge, edge) {
    if (longEdge === 1 || (longEdge === 2 && edge === 2)) {
        return CornerCabinetDirection.Right;
    }
    return CornerCabinetDirection.Left;
}
// 判断该categoryId是否是转角柜
export function isCornerCabinet(categoryId) {
    const { CATEGORY_8, CATEGORY_9, CATEGORY_27, CATEGORY_28, } = FRAMECATEGORY;
    const cornerCabinetArr = [CATEGORY_8, CATEGORY_9, CATEGORY_27, CATEGORY_28];
    return cornerCabinetArr.includes(categoryId);
}
export function isHighCabinet(categoryId) {
    const { CATEGORY_10, CATEGORY_11, CATEGORY_12, CATEGORY_33, CATEGORY_34, CATEGORY_35, CATEGORY_36, CATEGORY_37, } = FRAMECATEGORY;
    const highCabinetArr = [CATEGORY_10, CATEGORY_11, CATEGORY_12, CATEGORY_33,
        CATEGORY_34, CATEGORY_35, CATEGORY_36, CATEGORY_37];
    return highCabinetArr.includes(categoryId);
}
export function isFridge(categoryId) {
    const { CATEGORY_39, } = FRAMECATEGORY;
    const fridgeArr = [CATEGORY_39];
    return fridgeArr.includes(categoryId);
}
/**
 * 获取frame的位置信息,水槽、燃气灶排列方向所在边
 * @param templateJson template
 * @param frameName 燃气灶或者水槽
 * @returns 燃气灶或者水槽的位置信息
 */
export function getFramePositionInfo(templateJson, frameName) {
    var _a, _b;
    const framePosition = {};
    const { frames } = getAllBottomFrame(templateJson);
    let frameInfo = null;
    for (let j = 0; j < frames.length; j += 1) {
        for (let i = 0; i < frames[j].length; i += 1) {
            const element = frames[j][i];
            const { longEdge, categoryId } = element;
            if (element[frameName]) {
                frameInfo = element[frameName];
                // 判断frame是否在转角柜上面  水槽转角柜  灶台转角柜
                if (categoryId === FRAMECATEGORY.CATEGORY_27 || categoryId === FRAMECATEGORY.CATEGORY_28) {
                    framePosition.cornerCabinetDirection = getCornerCabinetDirection(longEdge, j + 1);
                    // 判断frame具体所在的边   如果右转角且长边在l1 那么frame在l1 如果左转角且长边在l3 那么frame在l3  剩下的情况都在l2
                    // eslint-disable-next-line max-depth
                    if (framePosition.cornerCabinetDirection === CornerCabinetDirection.Right && longEdge === 1) {
                        framePosition.location = 1;
                    }
                    else if (framePosition.cornerCabinetDirection === CornerCabinetDirection.Left && longEdge === 3) {
                        framePosition.location = 3;
                    }
                    else {
                        framePosition.location = 2;
                    }
                }
                else {
                    framePosition.location = j + 1;
                }
                framePosition.cabinetId = (_a = element === null || element === void 0 ? void 0 : element.componentBasic) === null || _a === void 0 ? void 0 : _a.id;
                framePosition.id = (_b = element[frameName].componentBasic) === null || _b === void 0 ? void 0 : _b.id;
                return Object.assign(Object.assign({}, framePosition), { frameInfo });
            }
        }
    }
    return Object.assign(Object.assign({}, framePosition), { frameInfo });
}
/**
 * 处理length的隐藏对象
 * @param lengthObj length对象
 * @param type 隐藏的类型
 * @returns 隐藏的mesh 的idArr
 */
export function handleLengthObj(lengthObj, type) {
    var _a, _b, _c, _d;
    if (!lengthObj || lengthObj.length === 0)
        return [];
    const idArr = [];
    const tmpLengthObj = JSON.parse(JSON.stringify(lengthObj));
    switch (type) {
        case 'l2':
            // l2 隐藏l2的最后一个位置的柜体  底柜
            if (tmpLengthObj.frames.length !== 1) {
                tmpLengthObj.sealPlate = [];
            }
            tmpLengthObj.frames = [tmpLengthObj.frames[tmpLengthObj.frames.length - 1]].filter((item) => item);
            break;
        case 'l3':
            // 当L型顶柜为l2，l3的时候 转角柜在l2的第一个位置，在隐藏l3的时候需要将其一起隐藏。
            tmpLengthObj.frames = [tmpLengthObj.frames[0]].filter((item) => item);
            break;
        case 'sealPlate':
            // 只隐藏补板把frames内的内容清空
            tmpLengthObj.frames = [];
            break;
        default:
            break;
    }
    if ((_a = tmpLengthObj === null || tmpLengthObj === void 0 ? void 0 : tmpLengthObj.frames) === null || _a === void 0 ? void 0 : _a.length) {
        const framesArr = tmpLengthObj.frames;
        framesArr.forEach((item) => {
            var _a, _b;
            idArr.push(item.componentBasic.id);
            if ((_a = item.accessories) === null || _a === void 0 ? void 0 : _a.length) {
                item.accessories.forEach((accessoriesItem) => {
                    idArr.push(accessoriesItem.componentBasic.id);
                });
            }
            if ((_b = item.doors) === null || _b === void 0 ? void 0 : _b.length) {
                item.doors.forEach((doorItem) => {
                    idArr.push(doorItem.componentBasic.id);
                });
            }
            if (item.stove) {
                idArr.push(item.stove.componentBasic.id);
            }
            if (item.sink) {
                idArr.push(item.sink.componentBasic.id);
            }
            if (item.ventilator) {
                idArr.push(item.ventilator.componentBasic.id);
            }
        });
    }
    if ((_b = tmpLengthObj === null || tmpLengthObj === void 0 ? void 0 : tmpLengthObj.sealPlate) === null || _b === void 0 ? void 0 : _b.length) {
        const sealPlateArr = tmpLengthObj === null || tmpLengthObj === void 0 ? void 0 : tmpLengthObj.sealPlate;
        sealPlateArr.forEach((item) => {
            idArr.push(item.id);
        });
    }
    if ((_c = tmpLengthObj === null || tmpLengthObj === void 0 ? void 0 : tmpLengthObj.sidePlates) === null || _c === void 0 ? void 0 : _c.length) {
        const sidePlatesArr = tmpLengthObj === null || tmpLengthObj === void 0 ? void 0 : tmpLengthObj.sidePlates;
        sidePlatesArr.forEach((item) => {
            idArr.push(item.id);
        });
    }
    if ((_d = tmpLengthObj === null || tmpLengthObj === void 0 ? void 0 : tmpLengthObj.sidePlatesV2) === null || _d === void 0 ? void 0 : _d.length) {
        const sidePlatesArr = tmpLengthObj === null || tmpLengthObj === void 0 ? void 0 : tmpLengthObj.sidePlatesV2;
        sidePlatesArr.forEach((item) => {
            idArr.push(item.componentBasic.id);
        });
    }
    return idArr;
}
// U+L型的话 判断旋转位置  需要隐藏 L1+L2上的补板   顶柜切换之后就是l3+l2上的补板
// U+I的话顶柜在l2的时候啥也不用干 在l1或l3的时候全部隐藏掉
export function handleJson(json) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    let XNeedHideMeshIdList = [];
    let P2XNeedHideMeshIdList = [];
    const { type, length } = getTopCabinetLengthInfo(json === null || json === void 0 ? void 0 : json.top);
    switch (json.bottom.type) {
        case 'H':
            XNeedHideMeshIdList = [...handleLengthObj((_a = json === null || json === void 0 ? void 0 : json.bottom) === null || _a === void 0 ? void 0 : _a.length1), ...handleLengthObj((_b = json === null || json === void 0 ? void 0 : json.top) === null || _b === void 0 ? void 0 : _b.length1)];
            P2XNeedHideMeshIdList = [...handleLengthObj((_c = json === null || json === void 0 ? void 0 : json.bottom) === null || _c === void 0 ? void 0 : _c.length3), ...handleLengthObj((_d = json === null || json === void 0 ? void 0 : json.top) === null || _d === void 0 ? void 0 : _d.length3)];
            break;
        default:
            XNeedHideMeshIdList = [
                ...handleLengthObj((_e = json === null || json === void 0 ? void 0 : json.bottom) === null || _e === void 0 ? void 0 : _e.length1),
                ...handleLengthObj((_f = json === null || json === void 0 ? void 0 : json.top) === null || _f === void 0 ? void 0 : _f.length1),
                ...handleLengthObj((_g = json === null || json === void 0 ? void 0 : json.bottom) === null || _g === void 0 ? void 0 : _g.length2, 'sealPlate'),
            ];
            P2XNeedHideMeshIdList = [
                ...handleLengthObj((_h = json === null || json === void 0 ? void 0 : json.bottom) === null || _h === void 0 ? void 0 : _h.length2, 'l2'),
                ...handleLengthObj((_j = json === null || json === void 0 ? void 0 : json.bottom) === null || _j === void 0 ? void 0 : _j.length3),
                ...handleLengthObj((_k = json === null || json === void 0 ? void 0 : json.top) === null || _k === void 0 ? void 0 : _k.length3),
            ];
            if (json.bottom.type === 'U_S' && ((_l = json === null || json === void 0 ? void 0 : json.bottom) === null || _l === void 0 ? void 0 : _l.length2.frames.length) === 0 && ((_m = json === null || json === void 0 ? void 0 : json.bottom) === null || _m === void 0 ? void 0 : _m.length2.sealPlate)) {
                P2XNeedHideMeshIdList.push(...handleLengthObj((_o = json === null || json === void 0 ? void 0 : json.bottom) === null || _o === void 0 ? void 0 : _o.length2, 'sealPlate'));
            }
            // 如果是L型才需要隐藏顶柜的l2部分    I字型啥也不用动
            if (type === 'L') {
                // 如果是l3的L型 那么隐藏l3的全部以及l2的第一个柜子
                if (length.includes('length3')) {
                    P2XNeedHideMeshIdList.push(...handleLengthObj((_p = json === null || json === void 0 ? void 0 : json.top) === null || _p === void 0 ? void 0 : _p.length2, 'l3'));
                }
                else {
                    XNeedHideMeshIdList.push(...handleLengthObj((_q = json === null || json === void 0 ? void 0 : json.top) === null || _q === void 0 ? void 0 : _q.length2, 'sealPlate'));
                }
            }
            break;
    }
    return {
        XNeedHideMeshIdList,
        P2XNeedHideMeshIdList,
    };
}
/**
 * 分离冰箱frame
 * @param json templatejson的底柜json或者顶柜json
 * @returns 无冰箱的frames,冰箱所在的length,冰箱的frame
 */
export function separateRefrigeratorFrame(json) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    const frames = [];
    let refrigeratorFrame = null;
    let refrigeratorLength = 1;
    if (((_b = (_a = json === null || json === void 0 ? void 0 : json.length1) === null || _a === void 0 ? void 0 : _a.frames) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        if (((_e = (_c = json === null || json === void 0 ? void 0 : json.length1) === null || _c === void 0 ? void 0 : _c.frames[((_d = json === null || json === void 0 ? void 0 : json.length1) === null || _d === void 0 ? void 0 : _d.frames.length) - 1]) === null || _e === void 0 ? void 0 : _e.categoryId) === 39) {
            refrigeratorFrame = (_f = json === null || json === void 0 ? void 0 : json.length1) === null || _f === void 0 ? void 0 : _f.frames[((_g = json === null || json === void 0 ? void 0 : json.length1) === null || _g === void 0 ? void 0 : _g.frames.length) - 1];
            (_h = json === null || json === void 0 ? void 0 : json.length1) === null || _h === void 0 ? void 0 : _h.frames.pop();
        }
        frames.push((_j = json === null || json === void 0 ? void 0 : json.length1) === null || _j === void 0 ? void 0 : _j.frames);
    }
    if (((_l = (_k = json === null || json === void 0 ? void 0 : json.length2) === null || _k === void 0 ? void 0 : _k.frames) === null || _l === void 0 ? void 0 : _l.length) > 0) {
        if (((_p = (_m = json === null || json === void 0 ? void 0 : json.length2) === null || _m === void 0 ? void 0 : _m.frames[((_o = json === null || json === void 0 ? void 0 : json.length2) === null || _o === void 0 ? void 0 : _o.frames.length) - 1]) === null || _p === void 0 ? void 0 : _p.categoryId) === 39) {
            refrigeratorLength = 2;
            refrigeratorFrame = (_q = json === null || json === void 0 ? void 0 : json.length2) === null || _q === void 0 ? void 0 : _q.frames[((_r = json === null || json === void 0 ? void 0 : json.length2) === null || _r === void 0 ? void 0 : _r.frames.length) - 1];
            (_s = json === null || json === void 0 ? void 0 : json.length2) === null || _s === void 0 ? void 0 : _s.frames.pop();
        }
        frames.push((_t = json === null || json === void 0 ? void 0 : json.length2) === null || _t === void 0 ? void 0 : _t.frames);
    }
    if (((_v = (_u = json === null || json === void 0 ? void 0 : json.length3) === null || _u === void 0 ? void 0 : _u.frames) === null || _v === void 0 ? void 0 : _v.length) > 0) {
        if (((_y = (_w = json === null || json === void 0 ? void 0 : json.length3) === null || _w === void 0 ? void 0 : _w.frames[((_x = json === null || json === void 0 ? void 0 : json.length3) === null || _x === void 0 ? void 0 : _x.frames.length) - 1]) === null || _y === void 0 ? void 0 : _y.categoryId) === 39) {
            refrigeratorLength = 3;
            refrigeratorFrame = (_z = json === null || json === void 0 ? void 0 : json.length3) === null || _z === void 0 ? void 0 : _z.frames[((_0 = json === null || json === void 0 ? void 0 : json.length3) === null || _0 === void 0 ? void 0 : _0.frames.length) - 1];
            (_1 = json === null || json === void 0 ? void 0 : json.length3) === null || _1 === void 0 ? void 0 : _1.frames.pop();
        }
        frames.push((_2 = json === null || json === void 0 ? void 0 : json.length3) === null || _2 === void 0 ? void 0 : _2.frames);
    }
    return {
        frames,
        refrigeratorLength,
        refrigeratorFrame,
    };
}
export function getIsHighSinkCabinet(templateJson) {
    const { frames } = getAllBottomFrame(templateJson);
    const sinkAndStoveCabinetArr = frames.flat(1).filter((item) => [
        FRAMECATEGORY.CATEGORY_1, FRAMECATEGORY.CATEGORY_2,
        FRAMECATEGORY.CATEGORY_27, FRAMECATEGORY.CATEGORY_28
    ].includes(item.categoryId));
    if (sinkAndStoveCabinetArr[0].componentBasic.height === sinkAndStoveCabinetArr[1].componentBasic.height) {
        return false;
    }
    return true;
}
/**
 * 判断length是否同一高度，同一边不会出现高低高情况 所以直接连续判断就可以
 * @param frames length.frames
 * @returns 返回length是否有高低  如果有返回高柜体的info及高柜体的排列
 */
export function isSameHigh(frames) {
    if (!frames || !Array.isArray(frames) || frames.length < 1) {
        return {
            frameInfo: null, isAfterDirection: false,
        };
    }
    let frameInfo;
    let isAfterDirection;
    // 剔除高柜
    const tempFrames = frames.filter((item) => ![
        FRAMECATEGORY.CATEGORY_10,
        FRAMECATEGORY.CATEGORY_11,
        FRAMECATEGORY.CATEGORY_12,
        FRAMECATEGORY.CATEGORY_33,
        FRAMECATEGORY.CATEGORY_34,
        FRAMECATEGORY.CATEGORY_35,
        FRAMECATEGORY.CATEGORY_36,
        FRAMECATEGORY.CATEGORY_37,
        FRAMECATEGORY.CATEGORY_39,
    ].includes(item.categoryId));
    for (let i = 1; i < tempFrames.length; i += 1) {
        if (tempFrames[i].componentBasic.height !== tempFrames[i - 1].componentBasic.height) {
            if (tempFrames[i].componentBasic.height === 800) {
                frameInfo = tempFrames[i];
                isAfterDirection = true;
            }
            else {
                frameInfo = tempFrames[i - 1];
                isAfterDirection = false;
            }
            break;
        }
    }
    if (frameInfo) {
        return {
            frameInfo, isAfterDirection,
        };
    }
    return { frameInfo, isAfterDirection };
}
// 判断高低柜的分界点 默认已经调用了上面的方法 确定是高低柜
export function getDividingPosition(templateJson) {
    // 获取水槽和灶台的位置信息
    const { length1, length2, length3 } = templateJson.bottom;
    const tempLength1 = JSON.parse(JSON.stringify(length1.frames));
    let tempLength2;
    let tempLength3;
    // 如果l2存在
    if (length2 === null || length2 === void 0 ? void 0 : length2.frames) {
        tempLength2 = JSON.parse(JSON.stringify(length2.frames));
        tempLength2.unshift(length1.frames[0]);
    }
    if (length3 === null || length3 === void 0 ? void 0 : length3.frames) {
        tempLength3 = JSON.parse(JSON.stringify(length3.frames));
        if ((length2 === null || length2 === void 0 ? void 0 : length2.frames) && (length2 === null || length2 === void 0 ? void 0 : length2.frames.length) !== 0) {
            tempLength3.unshift(length2.frames[length2.frames.length - 1]);
        }
    }
    const l1Frame = isSameHigh(tempLength1);
    const l2Frame = isSameHigh(tempLength2);
    const l3Frame = isSameHigh(tempLength3);
    return {
        l1Frame, l2Frame, l3Frame,
    };
}
